import React from "react";
import { footerHolder } from "./Footer.module.scss";
import LinkedIn from "../images/icons/LinkedIn";
import Instagram from "../images/icons/Instagram";
import Facebook from "../images/icons/Facebook";

export default function Footer() {
  return (
    <footer className={footerHolder}>
      <div className="copyright">
        <p>&copy; {new Date().getFullYear()} The Creatives</p>
      </div>
      <ul className="socials">
        <li>
          <a
            href="https://www.instagram.com/thecreativesorg"
            aria-label="The Creatives Instagram"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            <Instagram />
          </a>
        </li>
        <li>
          <a
            href="https://www.linkedin.com/company/the-creatives-org/"
            aria-label="The Creatives LinkedIn"
            target="_blank"
            rel="noopener noreferrer"
          >
            <LinkedIn />
          </a>
        </li>
        <li>
          <a
            href="https://www.facebook.com/thecreativesorg"
            aria-label="The Creatives Facebook"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Facebook />
          </a>
        </li>
      </ul>
      <div className="credit">
        <p>
          Site by <a href="https://www.sitesbylookup.com">Look Up!</a>
        </p>
      </div>
    </footer>
  );
}
